exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gift-area .slick-slide img{\r\n    width: unset;\r\n}\r\n.gift-area{\r\n    padding: 80px 0;\r\n    padding-bottom: 0;\r\n}\r\n.gift-area .section-title p {\r\n    max-width: 640px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.gift-item {\r\n    padding: 70px 0;\r\n}", ""]);

